module.exports = __webpack_public_path__ + "static/img/risk_01_202512.5c21e6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/risk/risk_01_202512.jpg
// module id = 2STN
// module chunks = 100